import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";
import { AuthApiService } from "../api/auth.api.service";
import { AuthService } from "./auth.service";
import { AuthEffects } from "./state/effects/auth.effects";
import * as fromAuth from "./state/reducers";

export function provideAuthApi() {
    return [AuthApiService];
}

export function provideAuthStore() {
    return [
        provideState(fromAuth.featureKey, fromAuth.reducers),
        provideEffects([AuthEffects]),
        AuthService,
    ];
}
